import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.sociasRequisitos;

const sociasCaracteristicasService = {
  async listBySocia(sociaId) {
    const url = `${API_BASE_URL}/caracteristicas/${encodeURIComponent(sociaId)}`;
    const res = await axios.get(url);
    return Array.isArray(res?.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
  },

  async addCaracteristica(sociaId, caracteristicaId) {
    const url = `${API_BASE_URL}/crear/caracteristica`;
    const body = { socia_id: sociaId, caracteristica_id: caracteristicaId };
    const res = await axios.post(url, body);
    return res?.data || { ok: true };
  },

  async removeCaracteristica(sociaId, caracteristicaId) {
    const url = `${API_BASE_URL}/eliminar/caracteristica/${encodeURIComponent(sociaId)}/${encodeURIComponent(caracteristicaId)}`;
    const res = await axios.delete(url);
    return res?.data || { ok: true };
  }
};

export default sociasCaracteristicasService;
